export default __webpack_public_path__ + "static/media/planet-4.43b5ab5c.svg";